












































































import Vue from "vue";
import Component from "vue-class-component";
import {useRentalStore} from "@/store/rental";
import type {RentalDevice} from "@/api/models/rental";

@Component({
  metaInfo: {
    title: "Leihgeräte",
  },
})
export default class RentalDevicesCatalog extends Vue {
  public isLoading = true;

  public get rentalDevices(): RentalDevice[] {
    return useRentalStore().rentalDevices;
  }

  public get availableDevices(): RentalDevice[] {
    return this.rentalDevices.filter(d => d.isAvailable);
  }

  public async mounted(): Promise<void> {
    await this.loadDevices();
  }

  public async loadDevices(): Promise<void> {
    this.isLoading = true;
    try {
      const rentalStore = useRentalStore();
      await rentalStore.fetchRentalDevices(true);
    } catch (e) {
      console.error("Error loading rental devices:", e);
    } finally {
      this.isLoading = false;
    }
  }

  public getImageUrl(imageId: number): string {
    const rentalStore = useRentalStore();
    return rentalStore.getImageUrl(imageId);
  }

  public isVideo(contentType: string): boolean {
    return contentType === "video/mp4";
  }

  public formatPrice(price: number): string {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
    }).format(price);
  }
}
